<script>
  import AppPageHeader from '../../../components/main/PageHeader'
  import EmptyList from '../../../components/list/EmptyList'
  import ImprimirBoleto from './ImprimirBoleto'
  import PagarOnline from './PagarOnline'

  import * as restfulService from '../../../services/restfulService'

  import bus from '@utils/bus'
  import helpers from '@mixins/helper'

  import {isEmpty} from 'lodash'

  export default {
    mixins: [helpers],
    components: {AppPageHeader, EmptyList, ImprimirBoleto, PagarOnline},
    mounted () {
      this.buscarTitulos()
    },
    data () {
      return {
        titulos: [],
        mostrarModalPdf: false,
        pdfBase64: ''
      }
    },
    computed: {
      titulosVazio: function () {
        return isEmpty(this.titulos)
      }
    },
    methods: {
      buscarTitulos () {
        bus.$emit('show-loader')
        this.titulos.splice(0)
        restfulService.post('titulo', 'meus-titulos')
          .then((response) => {
            this.titulos = [...this.titulos, ...response]
            bus.$emit('hide-loader')
          })
          .catch(e => {
            bus.$emit('hide-loader')
            console.log(e)
          })
      },
      imprimirPdf (item) {
        bus.$emit('show-loader')
        restfulService.get('boleto', 'pdf', item.id)
          .then((response) => {
            this.pdfBase64 = 'data:application/pdf;base64,' + response.base64
            this.mostrarModalPdf = true
            bus.$emit('hide-loader')
          })
          .catch(e => {
            bus.$emit('hide-loader')
            console.log(e)
          })
      },
      formataValorDesconto (valorDesconto, valor) {
        if (valorDesconto > 0) {
          return 'R$ ' + this.currencyEnToBr(valor - valorDesconto)
        }

        return ''
      }
    }
  }
</script>

<template>
    <div class="page-content">
        <app-page-header/>
        <div class="box">
            <empty-list v-if="titulosVazio"
                        title="Nenhuma cobrança encontrada"
                        description="Até o momento, nenhuma cobrança foi encontrada. Tente novamente mais tarde"/>
            <div v-if="!titulosVazio">
                <h3 class="page-content-title">
                  <small class="red--text">
                    * Após o vencimento pode ocorrer a incidência de juros e multa
                  </small>
                </h3>
                <div class="responsive-table">
                    <table class="v-table">
                        <thead>
                        <tr>
                            <th>Descrição</th>
                            <th>Parcela</th>
                            <th>Período</th>
                            <th>Valor c/ desconto (R$)</th>
                            <th>Data desconto</th>
                            <th>Valor até o vencimento (R$)</th>
                            <th>Data vencimento</th>
                            <th>Boleto/Pagamento online</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="item in titulos">
                            <td>{{item.obs}}</td>
                            <td>{{item.titulo_matricula ? item.titulo_matricula.num_parcela : ''}}</td>
                            <td>{{item.titulo_matricula ? item.titulo_matricula.ref_periodo : ''}}</td>
                            <td>{{formataValorDesconto(item.dados_boleto.valor_desconto, item.dados_boleto.valor)}}</td>
                            <td>{{item.dados_boleto.data_desconto | dateEnToBr}}</td>
                            <td>R$ {{item.dados_boleto.valor | currencyEnToBr}} <sup class="red--text">*</sup></td>
                            <td>{{item.dt_vencimento | dateEnToBr}}</td>
                            <td>
                              <div class="d-inline-flex">
                                <span v-if="item.protestado" class="red--text text--darken-4">
                                  Boleto bloqueado<br>
                                  Entre em contato com a central de atendimento para verificar a situação
                                </span>
                                <span v-if="item.titulo_anterior_pendente && !item.protestado" class="amber--text text--darken-4">
                                  Boleto anterior pendente
                                </span>
                                <template v-if="!item.titulo_anterior_pendente && !item.protestado">
                                  <imprimir-boleto :key="`${item.id}-ib`" :titulo="item"/>
                                  <pagar-online :key="`${item.id}-po`" :titulo="item"/>
                                </template>
                              </div>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>



// WEBPACK FOOTER //
// MinhasCobrancas.vue?5bc6c7ca